import NewsSection from './NewsSection';

export default NewsSection;
